import moment from 'moment'
import { getStoreKeyByName } from "@/Steps";
import { dateFormat, privacyOfficers } from "@/lib/settings";

const nameStoreFormValue = getStoreKeyByName('extras')

const defaultValue = {
  isDecisionMaking: false,
  decisionMakingPurpose: '',
  decisionMakingHowWorks: '',
  decisionMakingHowAffects: '',
  supervisoryAuthorityCountry: null,
  supervisoryAuthorityCountryEUandEEA: false,
  supervisoryAuthorityName: '',
  supervisoryAuthorityLink: '',
  privacyOfficer: privacyOfficers[0],
  officerName: '',
  officerEmail: '',
  officerPhone: '',
  effectiveDate: moment().format(dateFormat),
}

export const extrasFormState = set =>  ({
  [nameStoreFormValue]:  defaultValue,
  setExtrasFormValue: value => set({ [nameStoreFormValue]: value}),
  resetExtrasFormData: () => set({ [nameStoreFormValue]: defaultValue  }),
})